import { baromoneyApi } from '@/api';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { between, include, } from '@/lib/query-parameter/filter';
import { injectSortParamHelper } from '@/lib/query-parameter/sortby';
import { workerBaromoneyHistoryWorkerStatusType } from '@/constants/workerBaromoneyHistory/workerBaromoneyHistoryWorkerStatusOptionList';
import PaginationOutput from '@/helpers/PaginationOutput';
export default {
    async getBaromoney() {
        const params = new QueryParameterBuilder()
            .build();
        const response = await baromoneyApi.getBaromoney(params);
        return response.data;
    },
    async getBaromoneyHistory({ betweenData = {}, pageNumber = 1, pageSize = 20 }) {
        const params = new QueryParameterBuilder()
            // todo: 서버 수정 요청 - 여러 테이블 매핑 오류
            // .addFields(field('memo', 'createdAt', 'type', 'transactionBaromoney'))
            .addFilters(include('type', '00', '01', 'X1'))
            .addFilters(between(betweenData))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .build();
        const response = await baromoneyApi.getBaromoneyHistory(params);
        return response.data;
    },
    async requestBaromoneyRemittance(data) {
        const response = await baromoneyApi.postBaromoneyRemittance(data);
        return response.data;
    },
    /**
     * 라이더 바로머니 내역 조회
     */
    async getWorkerBaromoneyHistory(payload) {
        const { pageSize, pageNumber, hubId, fromDate, toDate, workerStatus, workerBaromoneyType, searchType, searchKey, sortOption, } = payload;
        const params = new QueryParameterBuilder()
            .addPageSize(pageSize)
            .addPageNumber(pageNumber)
            .add('fromDate', fromDate)
            .add('toDate', toDate)
            .add('workerBaromoneyType', workerBaromoneyType);
        // 허브를 선택 한 경우 추가
        if (hubId) {
            params
                .add('hubId', hubId);
        }
        // 라이더 상태를 선택 한 경우 추가
        if (workerStatus !== workerBaromoneyHistoryWorkerStatusType.ALL) {
            params
                .add('workerStatus', workerStatus);
        }
        // 검색값이 있는 경우 추가
        if (searchKey) {
            params
                .add('searchType', searchType)
                .add('searchKey', searchKey);
        }
        if (sortOption[0].field) {
            injectSortParamHelper(params, sortOption);
        }
        const response = await baromoneyApi.getWorkerBaromoneyHistory(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 단일 라이더 바로머니 내역 조회
     */
    async getWorkerBaromoneyHistoryByWorkerCode(workerCode, payload) {
        const { pageSize, pageNumber, hubId, fromDate, toDate, sortOption, } = payload;
        const params = new QueryParameterBuilder()
            .addPageSize(pageSize)
            .addPageNumber(pageNumber)
            .add('hubId', hubId)
            .add('fromDate', fromDate)
            .add('toDate', toDate);
        if (sortOption[0].field) {
            injectSortParamHelper(params, sortOption);
        }
        const response = await baromoneyApi.getWorkerBaromoneyHistoryByWorkerCode(workerCode, params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 단일 라이더 수익 내역 조회
     */
    async getWorkerProfitByWorkerCode(workerCode, payload) {
        const { pageSize, pageNumber, hubId, fromDate, toDate, sortOption, } = payload;
        // 수익 조회 여부
        const isProfitSearch = true;
        const params = new QueryParameterBuilder()
            .addPageSize(pageSize)
            .addPageNumber(pageNumber)
            .add('hubId', hubId)
            .add('isProfitSearch', isProfitSearch)
            .add('fromDate', fromDate)
            .add('toDate', toDate);
        if (sortOption[0].field) {
            injectSortParamHelper(params, sortOption);
        }
        const response = await baromoneyApi.getWorkerBaromoneyHistoryByWorkerCode(workerCode, params.build());
        return PaginationOutput.adaptorFactory(response);
    },
};
